import { DateTime } from 'luxon'

export const formatBytes = (bytes: number, iec = false): string => {
  if (!Number.isFinite(bytes) || bytes === 0) return '0 B'
  const k = iec ? 1024 : 1000
  const sizes = iec ? ['B', 'KiB', 'MiB', 'GiB', 'TiB'] : ['B', 'KB', 'MB', 'GB', 'TB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i]
}

export const formatNumber = (num: number): string => {
  return new Intl.NumberFormat('de-DE').format(num)
}

// formatTimestampSeconds renders a Unix epoch-seconds value as a local-time
// string. Returns the em-dash placeholder when the value is missing.
export const formatTimestampSeconds = (
  secs: number | null | undefined,
  format = 'dd.MM.yyyy HH:mm'
): string => {
  if (secs === null || secs === undefined) return '—'
  const dt = DateTime.fromSeconds(secs)
  if (!dt.isValid) return String(secs)
  return dt.toFormat(format)
}
